// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import { Validator } from 'vee-validate';
import { sync } from 'vuex-router-sync';
import vuexStore from './vuex/store';

// Importação de código de configuração/criação criados.
import plugins from './config/plugins';
import directives from './config/directives';
import validations from './config/validations';
import theme from './config/theme/theme';
import interceptors from './config/interceptors';
import configRouter from './config/router/';
import i18n from './config/i18n';
import Banner from "vue-banner-better";
import axios from 'axios'
// import VueAxios from 'vue-axios'


plugins(Vue, Vuex, VueRouter);
directives(Vue);
theme(Vue);
validations(Validator);
interceptors(Vue);

// Importando o componente raíz onde a app será renderizada.
import App from './App'; // eslint-disable-line

const store = new Vuex.Store(vuexStore);
const router = configRouter(VueRouter);

// Sincronização entre rotas e vuex.
// Garante o estado da store em todas as páginas SPA.
sync(store, router);
const i18nData = i18n(Vue);
i18nData.locale = 'pt-br';
Vue.use(Banner);
Vue.use(axios)

new Vue({ // eslint-disable-line no-new
    router,
    store,
    i18n: i18nData,
    el: '#app',
    template: '<App/>',
    components: { App },
    created: () => {},
});
// });


// WEBPACK FOOTER //
// ./src/main.js